import {HorizontalLoader, InfiniteScroll, TableCard} from 'mc/lib';
import {storeFromArea} from 'mc/lib/utils';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
    fetchZadostiIfNeeded,
    filterZadosti,
    loadMoreZadosti,
    reloadZadosti,
    ZADOST_LIST_AREA,
} from '../../actions/zadostListActions';
import DataTableContext from '../../components/datatable/DataTableContext';
import HasNewData from '../../components/HasNewData';
import ZadostFilter from '../../components/zadost/ZadostFilter';
import ZadostTable from '../../components/zadost/ZadostTable';

class ZadostListPageTab extends Component {

    componentDidMount() {
        this.fetchData(true);
    }

    componentDidUpdate() {
        this.fetchData(false);
    }

    fetchData(force) {
        const {dispatch} = this.props;
        dispatch(fetchZadostiIfNeeded(force));
    }

    loadMore = () => {
        this.props.dispatch(loadMoreZadosti());
    };

    handleReload = () => {
        this.props.dispatch(reloadZadosti());
    };

    handleFilterChange = values => {
        this.props.dispatch(filterZadosti(values));
    };

    renderHeader = () => {
        const {zadostiList} = this.props;
        return (
            <div className="header">
                <ZadostFilter values={zadostiList.filter}
                              onChange={this.handleFilterChange}/>
                {zadostiList.fetched && (
                    <div className="mt-3 mb-2">
                        Počet nalezených položek: <small className="font-weight-bold">{zadostiList.allIds.length}</small>
                    </div>
                )}
                {zadostiList.fetched && <ZadostTable rows={zadostiList.rows} headerOnly/>}
            </div>
        )
    };

    render() {
        const {zadostiList} = this.props;
        return (
            <DataTableContext>
                <TableCard className="inverse" header={this.renderHeader()}>
                    {zadostiList.hasNewIds && <HasNewData onReload={this.handleReload}/>}
                    <InfiniteScroll bordered
                                    loadMore={this.loadMore}
                                    hasMore={zadostiList.hasMore}>
                        {zadostiList.isFetching && <HorizontalLoader hover/>}
                        {zadostiList.fetched && <ZadostTable rows={zadostiList.rows} bodyOnly/>}
                    </InfiniteScroll>
                </TableCard>
            </DataTableContext>
        );
    }
}

const mapStateToProps = state => ({
    zadostiList: storeFromArea(state, ZADOST_LIST_AREA),
});

export default connect(mapStateToProps)(ZadostListPageTab);
